export const PrintConfActionTypes = {
  API_RESPONSE_SUCCESS: '@@print-conf/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@print-conf/API_RESPONSE_ERROR',

  UPDATE_PRINT_CONF: '@@print-conf/UPDATE_PRINT_CONF',

  RESET: '@@print-conf/RESET'
}
